export {DownloadComponent} from './component';
export {DownLoadService} from '../../service/download.service';

